import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute({ children }) {
  const { loading, isAuthed } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bone)] text-[var(--ink-soft)]">
        <span className="text-sm">Checking session…</span>
      </div>
    );
  }
  if (!isAuthed) return <Navigate to="/admin/login" replace />;
  return children;
}
